import { FC } from 'react'

import styled from 'styled-components'

import { AdsCountriesModalButtons } from './AdsCountriesButtons'
import { CountryOption } from './CountriesRadio'
import { SelectedCountriesList } from './SelectedCountriesList'
import { CustomCountriesSearch } from './CustomCountriesSeach'
import { useAdsCountries } from './useAdsCountries'
import { AdCampaignCountriesTierEnum, ADS_COUNTRIES } from './helpers'

const TitleContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
`

const Title = styled.div`
  color: ${(props) => props.theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
`
const Subtitle = styled(Title)`
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
`

const OptionsContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
`
const getSubtitle = (countriesCount: number, checked?: boolean): string => {
  if (countriesCount === 0 && !checked) {
    return ''
  }
  if (countriesCount === 1) {
    return '1 country'
  }
  return `${countriesCount} countries`
}

export const AdsCountriesModalContent: FC = () => {
  const {
    countriesTier,
    selectedCountries,
    disabledAdd,
    onCountryClick,
    onSaveCountries,
    setCountriesTier,
    onClose,
  } = useAdsCountries()

  return (
    <>
      <TitleContainer>
        <Title>Target locations</Title>
        <Subtitle>
          Choose your targeting strategy based on goals and budget
        </Subtitle>
      </TitleContainer>
      <OptionsContainer>
        <CountryOption
          checked={countriesTier === AdCampaignCountriesTierEnum.TOP_ENGAGED}
          onChange={() =>
            setCountriesTier(AdCampaignCountriesTierEnum.TOP_ENGAGED)
          }
          id={AdCampaignCountriesTierEnum.TOP_ENGAGED}
          name={AdCampaignCountriesTierEnum.TOP_ENGAGED}
          isRecommended
          title='Top engaged countries'
          subTitle={getSubtitle(
            ADS_COUNTRIES[AdCampaignCountriesTierEnum.TOP_ENGAGED].length,
          )}
          priceIconCount={0}
        >
          <SelectedCountriesList
            show={countriesTier === AdCampaignCountriesTierEnum.TOP_ENGAGED}
            countries={ADS_COUNTRIES[AdCampaignCountriesTierEnum.TOP_ENGAGED]}
          />
        </CountryOption>
        <CountryOption
          checked={countriesTier === AdCampaignCountriesTierEnum.CUSTOM}
          onChange={() => setCountriesTier(AdCampaignCountriesTierEnum.CUSTOM)}
          id={AdCampaignCountriesTierEnum.CUSTOM}
          name={AdCampaignCountriesTierEnum.CUSTOM}
          title='Custom Selection'
          subTitle={getSubtitle(
            selectedCountries.length,
            countriesTier === AdCampaignCountriesTierEnum.CUSTOM,
          )}
          priceIconCount={0}
        >
          <SelectedCountriesList
            key={AdCampaignCountriesTierEnum.CUSTOM}
            show={
              selectedCountries.length > 0 &&
              countriesTier === AdCampaignCountriesTierEnum.CUSTOM
            }
            countries={selectedCountries}
            editable
            onCountryClick={onCountryClick}
          />
        </CountryOption>
      </OptionsContainer>
      <CustomCountriesSearch
        selectedCountries={selectedCountries}
        onCountryClick={onCountryClick}
        show={countriesTier === AdCampaignCountriesTierEnum.CUSTOM}
      />
      <AdsCountriesModalButtons
        disabledAdd={disabledAdd}
        onClickAddCountries={onSaveCountries}
        onClickGoBack={onClose}
      />
    </>
  )
}
